export const LOADING_OVERVIEW = "LOADING_OVERVIEW";
export const SAVE_LOADING_OVERVIEW = "SAVE_LOADING_OVERVIEW";
export const GET_OVERVIEW = "GET_OVERVIEW";
export const FORM_FAIL = "FORM_FAIL";
export const OVERVIEW_FAIL = "OVERVIEW_FAIL";
export const LOADING_OVERVIEW_BY_ID = "LOADING_OVERVIEW_BY_ID";
export const GET_OVERVIEW_BY_ID = "GET_OVERVIEW_BY_ID";

